import React from "react";
import { company } from "../data/content";

function Brand({ inverse = false }) {
  return (
    <span className={`brand ${inverse ? "brand-inverse" : ""}`}>
      <img src={`${process.env.PUBLIC_URL}/mn2-mark.png`} alt="" className="brand-mark" />
      <span className="brand-text">
        <span className="brand-name">{company.name}</span>
        <span className="brand-tag">{company.tagline}</span>
      </span>
    </span>
  );
}

export default Brand;
